<template>
  <div class="outbound-pay">
    <div v-if="!paid" class="pay-wrap">
      <div class="section">
        <div class="section-title">商家信息</div>
        <div class="kv-row">
          <span class="kv-label">商家</span>
          <span class="kv-value">{{ orderInfo.merchName || "-" }}</span>
        </div>
      </div>

      <div class="section" v-if="products.length">
        <div class="section-title">商品明细</div>
        <div
          v-for="(item, idx) in products"
          :key="item.productId || idx"
          class="goods-item"
        >
          <div class="goods-left">
            <div class="goods-name">{{ item.productName }}</div>
          </div>
          <div class="goods-right">
            <div class="goods-price">¥{{ formatAmount(item.taxPrice) }}</div>
            <div class="goods-qty">x{{ item.orderNum }}</div>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">支付订单</div>
        <div class="kv-row">
          <span class="kv-label">原价</span>
          <span class="kv-value">¥{{ formatAmount(orderInfo.oriTotalAmount) }}</span>
        </div>
        <div class="kv-row" v-if="orderInfo.discountAmount">
          <span class="kv-label">优惠</span>
          <span class="kv-value discount">-¥{{ formatAmount(orderInfo.discountAmount) }}</span>
        </div>
        <div class="kv-row total-row">
          <span class="kv-label">总计</span>
          <span class="kv-value total">¥{{ formatAmount(orderInfo.payAmount) }}</span>
        </div>
      </div>
      <div class="section" v-if="remarkText">
        <div class="section-title">出库备注</div>
        <div class="remark-text">{{ remarkText }}</div>
      </div>

      <div class="section">
        <div class="section-title">选择出库方式</div>
        <van-radio-group v-model="payType">
          <div
            v-for="item in outboundMethods"
            :key="item.code"
            class="method-item"
            @click="payType = item.code"
          >
            <div class="method-left">
              <div class="method-icon" :class="item.iconClass">
                <van-icon :name="item.icon" size="22" />
              </div>
              <span class="method-name">{{ item.name }}</span>
            </div>
            <van-radio :name="item.code" checked-color="#1989fa" />
          </div>
        </van-radio-group>
      </div>

      <div class="bottom-bar">
        <van-button
          type="primary"
          block
          round
          color="#07c160"
          :loading="paying"
          @click="onPay"
        >
          立即支付
        </van-button>
        <van-button plain block round class="rescan-btn" @click="$emit('back')">
          {{ backText }}
        </van-button>
      </div>
    </div>

    <div v-else class="result-wrap">
      <div class="result-icon ok">
        <van-icon name="success" size="48" color="#fff" />
      </div>
      <div class="result-text">支付成功</div>
      <van-button plain round block class="back-btn" @click="backToWorkbench">
        返回工作台
      </van-button>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import { scanOutboundPay } from "../../../service/api/retail/manual-outbound";
import {
  OUTBOUND_METHODS,
  formatAmount,
  resolvePayFailMsg,
} from "./outbound-common";

export default {
  name: "outbound-pay",
  props: {
    orderId: { type: String, default: "" },
    orderInfo: { type: Object, default: () => ({}) },
    products: { type: Array, default: () => [] },
    backText: { type: String, default: "返回" },
    remark: { type: String, default: "" },
  },
  data() {
    return {
      paying: false,
      paid: false,
      payType: "1",
      outboundMethods: OUTBOUND_METHODS,
    };
  },
  computed: {
    remarkText() {
      return String(this.remark || "").trim();
    },
  },
  methods: {
    formatAmount,
    async onPay() {
      if (!this.orderId) {
        Toast.fail("请先获取待出库订单");
        return;
      }
      if (!this.payType) {
        Toast.fail("请选择出库方式");
        return;
      }
      this.paying = true;
      try {
        // 全部离线出库，不走支付网关；payType：1/9/10/11
        await scanOutboundPay({
          orderId: this.orderId,
          payType: this.payType,
        });
        this.paid = true;
      } catch (e) {
        Dialog.alert({
          message: resolvePayFailMsg(e),
          confirmButtonText: "知道了",
        });
      } finally {
        this.paying = false;
      }
    },
    backToWorkbench() {
      this.$router.replace("/dashboard/application");
    },
  },
};
</script>

<style scoped lang="less">
.pay-wrap {
  padding: 12px 12px 120px;
}

.section {
  background: #fff;
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 12px;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 10px;
}

.kv-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  font-size: 14px;
}

.kv-label {
  color: #969799;
}

.kv-value {
  color: #323233;
}

.total-row .total {
  color: #07c160;
  font-size: 20px;
  font-weight: 700;
}

.discount {
  color: #ee0a24;
}

.remark-text {
  font-size: 14px;
  line-height: 22px;
  color: #323233;
  white-space: pre-wrap;
  word-break: break-all;
}

.goods-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f2f3f5;

  &:last-child {
    border-bottom: none;
  }
}

.goods-name {
  font-size: 14px;
  color: #323233;
  padding-right: 12px;
}

.goods-right {
  text-align: right;
  flex-shrink: 0;
}

.goods-price {
  font-size: 14px;
  color: #323233;
}

.goods-qty {
  font-size: 12px;
  color: #969799;
  margin-top: 2px;
}

.method-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f2f3f5;

  &:last-child {
    border-bottom: none;
  }
}

.method-left {
  display: flex;
  align-items: center;
}

.method-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  color: #fff;

  &.cash {
    background: #f5a623;
  }
  &.wechat {
    background: #07c160;
  }
  &.alipay {
    background: #1677ff;
  }
  &.card {
    background: #722ed1;
  }
}

.method-name {
  font-size: 15px;
  color: #323233;
}

.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
}

.rescan-btn {
  margin-top: 8px;
}

.result-wrap {
  min-height: calc(100vh - 46px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.result-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &.ok {
    background: #07c160;
  }
}

.result-text {
  margin: 16px 0 32px;
  font-size: 18px;
  font-weight: 600;
  color: #323233;
}

.back-btn {
  width: 70%;
}
</style>
